
import { computed, defineComponent, onMounted, ref, toRefs, watch } from 'vue'

export default defineComponent({
  name: 'FrDropdown',
  props: {
    modelValue: {
      type: Boolean,
      default: () => false
    },
    optionsWidth: {
      type: [String, Number],
      default: () => '250px'
    },
    align: {
      type: String,
      default: () => 'left'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isOpen = ref(props.modelValue)
    const optionsContainer = ref<any>(null)

    const contentHeight = computed(() =>
      optionsContainer.value ? optionsContainer.value.clientHeight : 0
    )

    const handleClick = () => {
      isOpen.value = !isOpen.value
      emit('update:modelValue', isOpen.value)
    }

    watch(
      () => props.modelValue,
      (first: boolean, second: boolean) => {
        //// // console.log('cambio modelo', first, second)
        isOpen.value = props.modelValue
      }
    )

    return {
      isOpen,
      optionsContainer,
      contentHeight,
      handleClick
    }
  }
})
